export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto py-8">
      <h1 className="text-3xl font-bold mb-2">Terms of Service</h1>
      <p className="text-gray-400 text-sm mb-8">Last updated: February 17, 2026</p>

      <div className="prose prose-invert prose-gray max-w-none space-y-6 text-gray-300 leading-relaxed">
        <section>
          <h2 className="text-xl font-semibold text-white mb-3">1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Coherence Engine platform, including the mobile application,
            VS Code extension, web dashboard, CLI tools, and SDKs (collectively, the "Services"),
            you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these
            Terms, do not use the Services.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">2. Description of Services</h2>
          <p>
            Coherence Engine is an enterprise AI orchestration platform that provides agent
            coordination, knowledge sharing, and ecosystem monitoring capabilities. The Services
            include tools for development, deployment, and management of AI-powered workflows.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">3. Account Registration</h2>
          <p>
            To use certain features of the Services, you must create an account. You are responsible
            for maintaining the confidentiality of your account credentials and for all activities
            that occur under your account. You agree to notify us immediately of any unauthorized
            use of your account.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">4. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li>Use the Services for any unlawful purpose</li>
            <li>Attempt to gain unauthorized access to any part of the Services</li>
            <li>Interfere with or disrupt the Services or servers</li>
            <li>Reverse engineer or decompile any part of the Services</li>
            <li>Use the Services to transmit malware or harmful code</li>
            <li>Redistribute or resell access to the Services without authorization</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">5. Intellectual Property</h2>
          <p>
            The Services, including all software, documentation, and content, are owned by MSKAI
            and protected by intellectual property laws. Your use of the Services does not grant you
            ownership of any intellectual property rights in the Services.
          </p>
          <p className="mt-2">
            You retain ownership of all content and data you create or upload through the Services.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">6. AI Services</h2>
          <p>
            The Services utilize artificial intelligence models for various features. AI outputs are
            provided as suggestions and should be reviewed before use. We do not guarantee the
            accuracy, completeness, or suitability of AI-generated content for any particular
            purpose.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">7. Service Availability</h2>
          <p>
            We strive to maintain high availability of the Services but do not guarantee
            uninterrupted access. We may perform maintenance, updates, or modifications that
            temporarily affect availability. We will provide reasonable notice of planned downtime
            when possible.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">8. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by law, MSKAI shall not be liable for any indirect,
            incidental, special, consequential, or punitive damages arising from your use of the
            Services. Our total liability shall not exceed the amount you paid for the Services in
            the twelve months preceding the claim.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">9. Termination</h2>
          <p>
            We may suspend or terminate your access to the Services at any time for violation of
            these Terms or for any other reason with reasonable notice. Upon termination, your
            right to use the Services ceases immediately. You may export your data before
            termination.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">10. Changes to Terms</h2>
          <p>
            We may modify these Terms at any time. Material changes will be communicated via the
            Services or email. Continued use of the Services after changes constitutes acceptance
            of the updated Terms.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">11. Governing Law</h2>
          <p>
            These Terms are governed by the laws of Australia. Any disputes arising from these
            Terms shall be resolved in the courts of Victoria, Australia.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">12. Contact</h2>
          <p>
            For questions about these Terms, contact us at{' '}
            <a href="mailto:legal@multiskilled.ai" className="text-indigo-400 hover:text-indigo-300">
              legal@multiskilled.ai
            </a>.
          </p>
        </section>
      </div>
    </div>
  )
}
